export function get(ui, name) {
    if (!Array.isArray(ui.items)) {
        return null
    }

    const { items } = ui
    const find = item => item.name === name

    if (items.some(find)) {
        return items.find(find)
    }

    for (const ui of items) {
        const item = get(ui, name)

        if (item) {
            return item
        }
    }

    return null
}
